import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getOlvidoSuPsw({ form }) {
  var params = '?usuario=' + form.usuario.toUpperCase() + '&email=' + form.email;
  const url = `${webservice}/getOlvidoSuPwd${params}`;

  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
}
